<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <v-container>
        <h3>Help</h3>
        <v-card class="pa-2 mt-3">
            <v-card-text>
                <v-container class="text-center">
                    <h2 class="mb-2">POOFSA PH</h2>
                    <p>
                        Poofsa will provide you with a list of all the available commands and their usage.
                    </p>
                </v-container>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>

export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: 'Help',
};
</script>